/* https://stripe.com/docs/api/country_specs/list
 * https://www.iban.com/country-codes
 */

import {defineMessages} from '@formatjs/intl'

export const countryLabels = defineMessages({
    AE: {
        id: 'countries.label.country.AE',
        defaultMessage: 'United Arab Emirates',
    },
    AG: {
        id: 'countries.label.country.AG',
        defaultMessage: 'Antigua and Barbuda',
    },
    AL: {
        id: 'countries.label.country.AL',
        defaultMessage: 'Albania',
    },
    AM: {
        id: 'countries.label.country.AM',
        defaultMessage: 'Armenia',
    },
    AR: {
        id: 'countries.label.country.AR',
        defaultMessage: 'Argentina',
    },
    AT: {
        id: 'countries.label.country.AT',
        defaultMessage: 'Austria',
    },
    AU: {
        id: 'countries.label.country.AU',
        defaultMessage: 'Australia',
    },
    BA: {
        id: 'countries.label.country.BA',
        defaultMessage: 'Bosnia and Herzegovina',
    },
    BE: {
        id: 'countries.label.country.BE',
        defaultMessage: 'Belgium',
    },
    BG: {
        id: 'countries.label.country.BG',
        defaultMessage: 'Bulgaria',
    },
    BH: {
        id: 'countries.label.country.BH',
        defaultMessage: 'Bahrain',
    },
    BO: {
        id: 'countries.label.country.BO',
        defaultMessage: 'Bolivia',
    },
    CA: {
        id: 'countries.label.country.CA',
        defaultMessage: 'Canada',
    },
    CH: {
        id: 'countries.label.country.CH',
        defaultMessage: 'Switzerland',
    },
    CI: {
        id: 'countries.label.country.CI',
        defaultMessage: "Côte d'Ivoire",
    },
    CL: {
        id: 'countries.label.country.CL',
        defaultMessage: 'Chile',
    },
    CO: {
        id: 'countries.label.country.CO',
        defaultMessage: 'Colombia',
    },
    CR: {
        id: 'countries.label.country.CR',
        defaultMessage: 'Costa Rica',
    },
    CY: {
        id: 'countries.label.country.CY',
        defaultMessage: 'Cyprus',
    },
    CZ: {
        id: 'countries.label.country.CZ',
        defaultMessage: 'Czechia',
    },
    DE: {
        id: 'countries.label.country.DE',
        defaultMessage: 'Germany',
    },
    DK: {
        id: 'countries.label.country.DK',
        defaultMessage: 'Denmark',
    },
    DO: {
        id: 'countries.label.country.DO',
        defaultMessage: 'Dominican Republic',
    },
    EC: {
        id: 'countries.label.country.EC',
        defaultMessage: 'Ecuador',
    },
    EE: {
        id: 'countries.label.country.EE',
        defaultMessage: 'Estonia',
    },
    EG: {
        id: 'countries.label.country.EG',
        defaultMessage: 'Egypt',
    },
    ES: {
        id: 'countries.label.country.ES',
        defaultMessage: 'Spain',
    },
    ET: {
        id: 'countries.label.country.ET',
        defaultMessage: 'Ethiopia',
    },
    FI: {
        id: 'countries.label.country.FI',
        defaultMessage: 'Finland',
    },
    FR: {
        id: 'countries.label.country.FR',
        defaultMessage: 'France',
    },
    GB: {
        id: 'countries.label.country.GB',
        defaultMessage: 'United Kingdom',
    },
    GH: {
        id: 'countries.label.country.GH',
        defaultMessage: 'Ghana',
    },
    GM: {
        id: 'countries.label.country.GM',
        defaultMessage: 'Gambia',
    },
    GR: {
        id: 'countries.label.country.GR',
        defaultMessage: 'Greece',
    },
    GT: {
        id: 'countries.label.country.GT',
        defaultMessage: 'Guatemala',
    },
    GY: {
        id: 'countries.label.country.GY',
        defaultMessage: 'Guyana',
    },
    HK: {
        id: 'countries.label.country.HK',
        defaultMessage: 'Hong Kong',
    },
    HR: {
        id: 'countries.label.country.HR',
        defaultMessage: 'Croatia',
    },
    HU: {
        id: 'countries.label.country.HU',
        defaultMessage: 'Hungary',
    },
    ID: {
        id: 'countries.label.country.ID',
        defaultMessage: 'Indonesia',
    },
    IE: {
        id: 'countries.label.country.IE',
        defaultMessage: 'Ireland',
    },
    IL: {
        id: 'countries.label.country.IL',
        defaultMessage: 'Israel',
    },
    IS: {
        id: 'countries.label.country.IS',
        defaultMessage: 'Iceland',
    },
    IT: {
        id: 'countries.label.country.IT',
        defaultMessage: 'Italy',
    },
    JM: {
        id: 'countries.label.country.JM',
        defaultMessage: 'Jamaica',
    },
    JO: {
        id: 'countries.label.country.JO',
        defaultMessage: 'Jordan',
    },
    JP: {
        id: 'countries.label.country.JP',
        defaultMessage: 'Japan',
    },
    KE: {
        id: 'countries.label.country.KE',
        defaultMessage: 'Kenya',
    },
    KH: {
        id: 'countries.label.country.KH',
        defaultMessage: 'Cambodia',
    },
    KR: {
        id: 'countries.label.country.KR',
        defaultMessage: 'Korea',
    },
    KW: {
        id: 'countries.label.country.KW',
        defaultMessage: 'Kuwait',
    },
    LC: {
        id: 'countries.label.country.LC',
        defaultMessage: 'Saint Lucia',
    },
    LI: {
        id: 'countries.label.country.LI',
        defaultMessage: 'Liechtenstein',
    },
    LK: {
        id: 'countries.label.country.LK',
        defaultMessage: 'Sri Lanka',
    },
    LT: {
        id: 'countries.label.country.LT',
        defaultMessage: 'Lithuania',
    },
    LU: {
        id: 'countries.label.country.LU',
        defaultMessage: 'Luxembourg',
    },
    LV: {
        id: 'countries.label.country.LV',
        defaultMessage: 'Latvia',
    },
    MA: {
        id: 'countries.label.country.MA',
        defaultMessage: 'Morocco',
    },
    MD: {
        id: 'countries.label.country.MD',
        defaultMessage: 'Moldova',
    },
    MG: {
        id: 'countries.label.country.MG',
        defaultMessage: 'Madagascar',
    },
    MK: {
        id: 'countries.label.country.MK',
        defaultMessage: 'Republic of North Macedonia',
    },
    MN: {
        id: 'countries.label.country.MN',
        defaultMessage: 'Mongolia',
    },
    MO: {
        id: 'countries.label.country.MO',
        defaultMessage: 'Macao',
    },
    MT: {
        id: 'countries.label.country.MT',
        defaultMessage: 'Malta',
    },
    MU: {
        id: 'countries.label.country.MU',
        defaultMessage: 'Mauritius',
    },
    MX: {
        id: 'countries.label.country.MX',
        defaultMessage: 'Mexico',
    },
    MY: {
        id: 'countries.label.country.MY',
        defaultMessage: 'Malaysia',
    },
    NA: {
        id: 'countries.label.country.NA',
        defaultMessage: 'Namibia',
    },
    NG: {
        id: 'countries.label.country.NG',
        defaultMessage: 'Nigeria',
    },
    NL: {
        id: 'countries.label.country.NL',
        defaultMessage: 'Netherlands',
    },
    NO: {
        id: 'countries.label.country.NO',
        defaultMessage: 'Norway',
    },
    NZ: {
        id: 'countries.label.country.NZ',
        defaultMessage: 'New Zealand',
    },
    OM: {
        id: 'countries.label.country.OM',
        defaultMessage: 'Oman',
    },
    PA: {
        id: 'countries.label.country.PA',
        defaultMessage: 'Panama',
    },
    PE: {
        id: 'countries.label.country.PE',
        defaultMessage: 'Peru',
    },
    PH: {
        id: 'countries.label.country.PH',
        defaultMessage: 'Philippines',
    },
    PL: {
        id: 'countries.label.country.PL',
        defaultMessage: 'Poland',
    },
    PT: {
        id: 'countries.label.country.PT',
        defaultMessage: 'Portugal',
    },
    PY: {
        id: 'countries.label.country.PY',
        defaultMessage: 'Paraguay',
    },
    QA: {
        id: 'countries.label.country.QA',
        defaultMessage: 'Qatar',
    },
    RO: {
        id: 'countries.label.country.RO',
        defaultMessage: 'Romania',
    },
    RS: {
        id: 'countries.label.country.RS',
        defaultMessage: 'Serbia',
    },
    RW: {
        id: 'countries.label.country.RW',
        defaultMessage: 'Rwanda',
    },
    SA: {
        id: 'countries.label.country.SA',
        defaultMessage: 'Saudi Arabia',
    },
    SE: {
        id: 'countries.label.country.SE',
        defaultMessage: 'Sweden',
    },
    SG: {
        id: 'countries.label.country.SG',
        defaultMessage: 'Singapore',
    },
    SI: {
        id: 'countries.label.country.SI',
        defaultMessage: 'Slovenia',
    },
    SK: {
        id: 'countries.label.country.SK',
        defaultMessage: 'Slovakia',
    },
    SN: {
        id: 'countries.label.country.SN',
        defaultMessage: 'Senegal',
    },
    SV: {
        id: 'countries.label.country.SV',
        defaultMessage: 'El Salvador',
    },
    TH: {
        id: 'countries.label.country.TH',
        defaultMessage: 'Thailand',
    },
    TN: {
        id: 'countries.label.country.TN',
        defaultMessage: 'Tunisia',
    },
    TR: {
        id: 'countries.label.country.TR',
        defaultMessage: 'Turvalue',
    },
    TT: {
        id: 'countries.label.country.TT',
        defaultMessage: 'Trinidad and Tobago',
    },
    TZ: {
        id: 'countries.label.country.TZ',
        defaultMessage: 'Tanzania',
    },
    US: {
        id: 'countries.label.country.US',
        defaultMessage: 'United States of America',
    },
    UY: {
        id: 'countries.label.country.UY',
        defaultMessage: 'Uruguay',
    },
    UZ: {
        id: 'countries.label.country.UZ',
        defaultMessage: 'Uzbekistan',
    },
    VN: {
        id: 'countries.label.country.VN',
        defaultMessage: 'Viet Nam',
    },
    ZA: {
        id: 'countries.label.country.ZA',
        defaultMessage: 'South Africa',
    },
    BD: {
        id: 'countries.label.country.BD',
        defaultMessage: 'Bangladesh',
    },
    BJ: {
        id: 'countries.label.country.BJ',
        defaultMessage: 'Benin',
    },
    MC: {
        id: 'countries.label.country.MC',
        defaultMessage: 'Monaco',
    },
    NE: {
        id: 'countries.label.country.NE',
        defaultMessage: 'Niger',
    },
    SM: {
        id: 'countries.label.country.SM',
        defaultMessage: 'San Marino',
    },
    AZ: {
        id: 'countries.label.country.AZ',
        defaultMessage: 'Azerbaijan',
    },
    BN: {
        id: 'countries.label.country.BN',
        defaultMessage: 'Brunei Darussalam',
    },
    BI: {
        id: 'countries.label.country.BI',
        defaultMessage: 'Bhutan',
    },
    AO: {
        id: 'countries.label.country.AO',
        defaultMessage: 'Angola',
    },
    DZ: {
        id: 'countries.label.country.DZ',
        defaultMessage: 'Algeria',
    },
    TW: {
        id: 'countries.label.country.TW',
        defaultMessage: 'Taiwan',
    },
    BS: {
        id: 'countries.label.country.BS',
        defaultMessage: 'Bahamas',
    },
    BW: {
        id: 'countries.label.country.BW',
        defaultMessage: 'Botswana',
    },
    GA: {
        id: 'countries.label.country.GA',
        defaultMessage: 'Gabon',
    },
    LA: {
        id: 'countries.label.country.LA',
        defaultMessage: "Lao People's Democratic Republic",
    },
    MZ: {
        id: 'countries.label.country.MZ',
        defaultMessage: 'Mozambique',
    },
})
